import { AntCard as Card } from "@murm/ant";
import { PlusOutlined } from "@ant-design/icons";
import HighlightedText from "../../../components/search/HighlightedText";
import { PENDO_ID, pendoId } from "../../../lib/pendoIds";
import styles from "./TemplateCard.module.css";

const TemplateCard = ({ segments, onClick, onMouseEnter, onMouseLeave }) => {
  return (
    <Card
      {...pendoId(PENDO_ID.SEARCH_TEMPLATE_CARD)}
      hoverable
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      size="small"
      // No explicit padding override -- `size="small"` already gives this a compact 12px body
      // padding; the old "14px 16px" override was larger than that default, fighting the very
      // prop meant to keep these compact (real report: rows too tall, page overflowing).
      className={styles.card}
      classNames={{ body: styles.body }}
    >
      <PlusOutlined className={styles.icon} />
      <span className={styles.text}>
        <HighlightedText segments={segments} />
      </span>
    </Card>
  );
};

export default TemplateCard;
